export default __webpack_public_path__ + "media/images/services/service-05-370x250-e9a84b5233a142a457c0ca61ac79a458.jpg";